import { observer, inject } from "mobx-react";
import { Outlet } from "react-router-dom";
import { IconButton, Text } from "../UI";
import { useMobile } from "../utils/mobile";
import theme from "../UI/theme";
import NavImg from "../asserts/img/arrow_forward_ios.svg";
import NavImgWhite from "../asserts/img/arrow_forward_ios_white.svg";
import { useTranslation } from "react-i18next";

const PageHeader = ({ title, children, back, style }) => {
  const isMobile = useMobile();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: isMobile ? theme.color.blue : "transparent",
          alignItems: "center",
          gap: 10,
          margin: !isMobile ? "unset" : "unset",
          padding: isMobile ? 15 : 0,
          ...style,
        }}>
        {back && (
          <IconButton
            src={isMobile ? NavImgWhite : NavImg}
            label={t("common:back")}
            iconStyle={{ transform: !isRtl && "rotate(180deg)" }}
            onClick={back}
          />
        )}
        <Text.H2
          style={{
            fontSize: isMobile ? 20 : 26,
            marginInlineEnd: isMobile && "1em",
          }}
          color={isMobile ? "#FFFFFF" : `${theme.color.label}`}>
          {title}
        </Text.H2>
      </div>
      <Outlet />
    </>
  );
};

export default inject("userStore")(observer(PageHeader));
